import Vue from 'vue'

Vue.filter('webp', (url) => {
	if (!url) return ''
	url = url.replace(
		'/wp-content/uploads/',
		'/wp-content/webp-express/webp-images/uploads/'
	)
	return `${url}.webp`
})
